<div class="linear-bar-container">
  <div class="linear-bar" style="transform: translateX(-13.5%) scale(0.73, 1);"></div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/busy-indicator/busy-indicator-linear/busy-indicator-linear.html